import React, { Component } from "react";
import Icons from "../../icon"
export class TableIcon extends Component {
    render(){
        return(
            <>
                <div className="separator"></div>
                <Icons
                    name={this.props.IconName}
                    size={this.props.IconSize}
                    customClassName="icon-trash-can"   
                />
            </>
        )
    }
}